export default "__VITE_ASSET__c14261fb__"